// @ts-nocheck

import { createContext } from 'react';

type OpenKeysType = Array<string>;

type SportsMenuContextProps = {
  openKeys?: OpenKeysType;
};

export const SportsMenuContext = createContext<SportsMenuContextProps>({});
